// import React from "react";
import jwtDecode from "jwt-decode";
import {Auth} from "aws-amplify";
import gql from "graphql-tag"
import Messages from "../../../../helper/messages"
import {failStoreNotification, setScreenLoading} from "../../../../store/actions";
import store from "../../../../store/store";
import Config from "../../../../config/config";
import * as AWS from 'aws-sdk';
import UtilService from "../../../../helper/service";
import roles from "../../../../helper/roles";
import moment from "moment";

if(process.env.REACT_APP_ACCESSKEYID){
  AWS.config.update({
    accessKeyId: Config.CONFIG.ACCESSKEYID,
    secretAccessKey: Config.CONFIG.SECRETACCESSKEY,
    region: Config.CONFIG.REGION
  });
}


const checkRedirectPage = (data) => {
  let redirectToHome = "/user/profile"
  const overviewpage = localStorage.getItem("overviewRedirect")
  if (data && data.role_access && data.role_access.length > 0) {
    const trail_profile = data.role_access.filter((val) => val.access_name === "trial_profile");
    if (trail_profile.length > 0 && trail_profile[0].access_value) {
      redirectToHome = '/subscriber/user/profile';
    }
    const creator_dashboard = data.role_access.filter((val)=>val.access_name === "creator_dashboard");
    if (creator_dashboard.length > 0 && creator_dashboard[0].access_value) {
      if (!!overviewpage) {
        redirectToHome = overviewpage
      } else {
        redirectToHome = "/creator/dashboard"
      }
    } else if (UtilService.checkTrialAccess(data, roles['trial']['dashboard'])) {
      if(!!overviewpage) {
        redirectToHome = overviewpage
      } else {
        redirectToHome = "/subscriber/creator/dashboard"
      }
    } else {
      const participant_dashboard = data.role_access.filter((val)=>val.access_name === "participant_dashboard")
      if (participant_dashboard.length > 0 && participant_dashboard[0].access_value) {
        redirectToHome = "/participant/dashboard"
      }
    }
    if (data.hasOwnProperty("creator_on_board") && data.creator_on_board) {
      const creator_onboarding = data.role_access.filter((val) => val.access_name === "creator_onboarding");
      const trial_onboarding = data.role_access.filter((val) => val.access_name === "trial_onboarding");
      if (creator_onboarding.length > 0 && creator_onboarding[0].access_value) {
        redirectToHome = "/creator/onboarding"
      } else if (trial_onboarding.length > 0 && trial_onboarding[0].access_value) {
        redirectToHome = "/subscriber/creator/onboarding";
      }
    }
  }
  localStorage.removeItem("overviewRedirect")
  return redirectToHome
}

export const checkUserAuth = (props) => {
  const _this = props
  store.dispatch(setScreenLoading(true));
  let saveData = false
  const windowObject = window;
  Auth.currentAuthenticatedUser()
    .then(async (user) => {
      const decoded = jwtDecode(user.signInUserSession.idToken.jwtToken);
      decoded.authType = 0
      if (decoded.identities && decoded.identities[0]) {
        if (decoded.identities[0].providerName === "Google") {
          decoded.authType = 1
        } else {
          decoded.authType = 2
        }
      }
      // check if user exists in system
      const loginQuery = gql`
        query login($username: String!, $authtype: Float!, $timezone: String) {
          login(username: $username, authtype: $authtype, timezone: $timezone) {
            status
            messagecode
            message
            data
          }
        }
      `;
      _this.props.apolloClient.client.query({
        query: loginQuery,
        fetchPolicy: "no-cache",
        variables: {
          username: decoded.email.toLowerCase().trim(),
          authtype: decoded.authType,
          timezone: moment.tz.guess()
        }
      }).then(response => {
        // when user login success
        if (response.data.login && response.data.login.status === "true") {
          store.dispatch(setScreenLoading(false));
          if(response.data.login.data.documents && response.data.login.data.documents.length){
            const sessionData = {
              user_id:decoded.sub,
              auth_token:user.signInUserSession.accessToken.jwtToken,
              idToken:user.signInUserSession.idToken.jwtToken,
            }
            _this.setState({
              privacyData:response.data.login.data,
              sessionData:sessionData
            })            
          } else {
            localStorage.setItem('user_data', JSON.stringify(response.data.login.data))
            localStorage.setItem("user_id", decoded.sub)
            localStorage.setItem("auth_token", user.signInUserSession.accessToken.jwtToken)
            localStorage.setItem("idToken", user.signInUserSession.idToken.jwtToken)
            // _this.props.logoutUserSuccess(Object.assign(decoded, {user_id: decoded.sub}))
            window.location.replace(checkRedirectPage(response.data.login.data))

          }
        } else {
          // when user login fail
          if (response.data.login && response.data.login.messagecode) {
            if (response.data.login.messagecode === "userNotFound") {
              saveData = true
            } else {
              if(response.data.login.messagecode === 'accountLocked' || response.data.login.messagecode === 'accountDeactive'){
                if (windowObject?.Intercom) {
                  windowObject.Intercom("show")
                }
              }
              if (Messages.NOTIFICATIONS.ERROR[response.data.login.messagecode]) {
                removeStorageFields();
                store.dispatch(failStoreNotification(Messages.NOTIFICATIONS.ERROR[response.data.login.messagecode]));
              }
            }
            store.dispatch(setScreenLoading(false));
          } else {
            if (response.data.login.message) {
              removeStorageFields();
              store.dispatch(failStoreNotification(response.data.login.message))
              store.dispatch(setScreenLoading(false));
            }
          }
        }
        // sign up new user
        if (saveData) {
          // find default tenant for user
          const query = gql`
            query defaultTenant($email: String!) {
              defaultTenant(email: $email) {
                customer_name
                display_name
              }
            }
          `;
          _this.props.apolloClient.client.query({
            query: query,
            fetchPolicy: "no-cache",
            variables: {
              email: decoded.email.toLowerCase().trim(),
            }
          })
            .then(response => {
              if (response.data && response.data.defaultTenant && response.data.defaultTenant.customer_name && response.data.defaultTenant.display_name) {
                // save user in system
                const mutation = gql`
                  mutation signupGoogleNew($middlename: String, $authtype: Float! , $display: String, $customername: String, $lastname: String, $firstname: String, $username: String!, $rsc: String, $cognitousername: String, $timezone: String) {
                    signupGoogleNew(middlename: $middlename, authtype: $authtype, display: $display, customername: $customername, lastname: $lastname, firstname: $firstname, username: $username, rsc:$rsc, cognitousername: $cognitousername, timezone: $timezone) {
                      status
                      message
                      messagecode
                      data
                    }
                  }
                `;
                _this.props.apolloClient.client.mutate({
                  mutation: mutation,
                  variables: {
                    middlename: "",
                    authtype: decoded.authType,
                    display: response.data.defaultTenant && response.data.defaultTenant.display_name ? response.data.defaultTenant.display_name : "",
                    customername: response.data.defaultTenant && response.data.defaultTenant.customer_name ? response.data.defaultTenant.customer_name : "",
                    lastname: decoded.family_name ? decoded.family_name : "",
                    firstname: decoded.given_name ? decoded.given_name : "",
                    username: decoded.email ? decoded.email.toLowerCase().trim() : "",
                    rsc: _this.state.rscText ? _this.state.rscText : "",
                    cognitousername: user && user.username ? user.username : "",
                    timezone: moment.tz.guess()
                  }
                }).then(response => {
                  // when user signup success
                  if (response.data.signupGoogleNew.status === "true") {
                    store.dispatch(setScreenLoading(false));                    
                    if(response.data.signupGoogleNew.data.documents && response.data.signupGoogleNew.data.documents.length){
                      _this.setState({
                        privacyData:response.data.signupGoogleNew.data
                      })
                      const sessionData = {
                        user_id:decoded.sub,
                        auth_token:user.signInUserSession.accessToken.jwtToken,
                        idToken:user.signInUserSession.idToken.jwtToken,
                      }
                      _this.setState({
                        privacyData:response.data.signupGoogleNew.data,
                        sessionData:sessionData
                      })                      
                    } else { 
                      localStorage.setItem('user_data', JSON.stringify(response.data.signupGoogleNew.data))
                      localStorage.setItem("user_id", decoded.sub)
                      localStorage.setItem("auth_token", user.signInUserSession.accessToken.jwtToken)
                      localStorage.setItem("idToken", user.signInUserSession.idToken.jwtToken)
                      _this.props.logoutUserSuccess(Object.assign(decoded, {user_id: decoded.sub}))
                      window.location.replace(checkRedirectPage(response.data.signupGoogleNew.data))
                    }
                  } else {
                    // when user signup fail
                    let message = false
                    if (response.data.signupGoogleNew.messagecode) {
                      if(response.data.signupGoogleNew.messagecode === 'accountLocked' || response.data.signupGoogleNew.messagecode === 'accountDeactive'){
                        if (windowObject?.Intercom) {
                          windowObject.Intercom("show")
                        }
                      }
                      if (Messages.NOTIFICATIONS.ERROR[response.data.signupGoogleNew.messagecode]) {
                        message = Messages.NOTIFICATIONS.ERROR[response.data.signupGoogleNew.messagecode]
                      }
                    } else {
                      if (response.data.signupGoogleNew.message) {
                        message = response.data.signupGoogleNew.message
                      }
                    }
                    if (message) {
                      store.dispatch(failStoreNotification(message));
                    }
                    removeStorageFields();
                    _this.props.logoutUserSuccess(Object.assign(decoded, {user_id: decoded.sub}))
                    store.dispatch(setScreenLoading(false));
                  }
                }).catch(() => {
                  removeStorageFields();
                  store.dispatch(failStoreNotification(Messages.NOTIFICATIONS.ERROR.saveUserFail))
                  store.dispatch(setScreenLoading(false));
                });
              } else {
                removeStorageFields();
                store.dispatch(failStoreNotification(Messages.NOTIFICATIONS.ERROR.defaultTenantNotFound))
                store.dispatch(setScreenLoading(false));
              }
            })
        }
      })
    })
    .catch(() => {
      removeStorageFields();
      store.dispatch(setScreenLoading(false));
    });
}

const removeStorageFields = () => {
  localStorage.removeItem("auth_token");
  localStorage.removeItem("user_data");
  localStorage.removeItem("user_id");
  localStorage.removeItem("loggedIn");
  localStorage.removeItem("idToken");
}
